/******/ (() => { // webpackBootstrap
/*!****************************************!*\
  !*** ./src/js/check-color-swatches.js ***!
  \****************************************/
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var ALL_SWATCHES_MAP = new WeakMap();
function updateSwatches(root) {
  var _root$querySelector;
  var swatchesContainer = root.querySelector(".product-option-wrap");
  if (!swatchesContainer) return;
  var selectedSize = (_root$querySelector = root.querySelector('input[name="Size"]:checked')) === null || _root$querySelector === void 0 ? void 0 : _root$querySelector.value;
  var swatches = (ALL_SWATCHES_MAP.get(root) || []).filter(function (swatch) {
    var _input$getAttribute;
    var input = swatch.querySelector("input");
    var name = input === null || input === void 0 || (_input$getAttribute = input.getAttribute("name")) === null || _input$getAttribute === void 0 ? void 0 : _input$getAttribute.toLowerCase();
    return input && (name === "color" || name === "colour");
  });
  if (swatches.length === 0) return;
  if (!selectedSize && swatches.length === 0) return;
  var variants;
  try {
    var _root$querySelector2;
    var variantsRaw = (_root$querySelector2 = root.querySelector("#product-variants")) === null || _root$querySelector2 === void 0 ? void 0 : _root$querySelector2.textContent;
    if (!variantsRaw) return;
    variants = JSON.parse(variantsRaw);
  } catch (_unused) {
    return;
  }
  var onSaleColors = [];
  var regularColors = [];
  swatches.forEach(function (swatch) {
    var color = swatch.querySelector("input").value;
    var variant = selectedSize ? variants.find(function (v) {
      return v.option1 === color && v.option2 === selectedSize;
    }) : variants.find(function (v) {
      return v.option1 === color;
    });
    if (!variant) {
      return;
    }
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      onSaleColors.push(swatch);
    } else {
      regularColors.push(swatch);
    }
  });
  swatchesContainer.innerHTML = "";
  var onSaleContainer = document.createElement("div");
  onSaleContainer.classList.add("w-full", "flex", "flex-wrap", "gap-2");
  var legendLabel = root.querySelector(".current-variation-label");
  if (regularColors.length > 0) {
    var availableContainer = document.createElement("div");
    availableContainer.classList.add("w-full", "flex", "flex-wrap", "gap-2");
    regularColors.forEach(function (el) {
      return availableContainer.appendChild(el);
    });
    swatchesContainer.appendChild(availableContainer);
    if (onSaleColors.length > 0) {
      var title = document.createElement("div");
      title.textContent = "Colour on sale:";
      title.classList.add("text-sm", "basis-full", "font-normal");
      onSaleContainer.appendChild(title);
      onSaleColors.forEach(function (el) {
        return onSaleContainer.appendChild(el);
      });
      swatchesContainer.appendChild(onSaleContainer);
    }
    if (legendLabel) legendLabel.textContent = "Colour:";
  } else if (onSaleColors.length > 0) {
    onSaleColors.forEach(function (el) {
      return onSaleContainer.appendChild(el);
    });
    swatchesContainer.appendChild(onSaleContainer);
    if (legendLabel) legendLabel.textContent = "Colour on sale:";
  } else {
    if (legendLabel) legendLabel.textContent = "Colour:";
  }
}
document.querySelectorAll("product-info").forEach(function (info) {
  var allSwatches = _toConsumableArray(info.querySelectorAll(".option-swatch-image-block-js"));
  ALL_SWATCHES_MAP.set(info, allSwatches);
  updateSwatches(info);
  info.querySelectorAll('input[name="Size"]').forEach(function (input) {
    input.addEventListener("change", function () {
      return updateSwatches(info);
    });
  });
});
/******/ })()
;